module.exports = __webpack_public_path__ + "img/venue.01bf6ca4.svg";